import { REDIRECT_KEY_QUERY, REDIRECT_KEY_STORAGE } from '@constants';
import useAuth from '@contexts/AuthProvider';
import { Paper, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

export default function OAuthPage() {
  useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const { initialized } = useAuth();

  useEffect(() => {
    if (!initialized) return;

    const params = new URLSearchParams(location.search);
    const next = params.get(REDIRECT_KEY_QUERY) || sessionStorage.getItem(REDIRECT_KEY_STORAGE) || '/';

    sessionStorage.removeItem(REDIRECT_KEY_STORAGE);
    void navigate(next, { replace: true });
  }, [initialized, location.search, navigate]);

  return (
    <Paper>
      <Stack sx={{ gap: 1, textAlign: 'center' }}>
        <Typography variant="h5">
          <Trans i18nKey="auth.title" />
        </Typography>
        <Typography>
          <Trans i18nKey="auth.message" />
        </Typography>
      </Stack>
    </Paper>
  );
}
